export default __webpack_public_path__ + "media/images/home/slide_any_age_2022_sm-29c5487f81d858d3c0e81c0bdd1d14dd.jpg";